export default __webpack_public_path__ + "static/media/quicksand-regular.109d09e5.ttf";